export const GET_USER = 'GET_USER';
export const UPDATE_USER = 'UPDATE_USER';